import { Dialog } from "@bps/fluent-ui";

import { RolloutPackageDesiredConfigFormValues } from "../../rollout/rolloutFormValues";
import { RolloutPackageContextProvider } from "../context/rollout-package-context.provider";
import { EditRolloutPackageDesiredConfig } from "./EditRolloutPackageDesiredConfig";

export interface RolloutPackageConfigureDto {
  softwarePackageId: string;
  softwarePackageVersionId: string;
}

interface RolloutPackageDesiredConfigDialogProps {
  configureSoftwarePackage: RolloutPackageConfigureDto;
  onDismiss: () => void;
  onUpdate: (values: RolloutPackageDesiredConfigFormValues[]) => void;
  isReadOnly: boolean;
}

export const RolloutPackageDesiredConfigDialog: React.FC<RolloutPackageDesiredConfigDialogProps> = ({
  configureSoftwarePackage,
  onDismiss,
  onUpdate,
  isReadOnly
}) => {
  return (
    <Dialog
      dialogContentProps={{
        showCloseButton: true,
        title: "Edit Rollout Package Desired Configuration"
      }}
      minWidth="90%"
      maxWidth="90%"
      onDismiss={onDismiss}
      hidden={false}
    >
      <RolloutPackageContextProvider {...configureSoftwarePackage}>
        <EditRolloutPackageDesiredConfig
          configureSoftwarePackage={configureSoftwarePackage}
          onDismiss={onDismiss}
          onUpdate={onUpdate}
          isReadOnly={isReadOnly}
        />
      </RolloutPackageContextProvider>
    </Dialog>
  );
};
